export type ClaimsModel = Record<string, string | number>;

export enum ClaimKey {
  SUB = 'sub',
  USERNAME = 'http://fss.follett.com/claims/userName',
  LOCATION_TYPE = 'http://fss.follett.com/claims/locationType',
  USER_GUID = 'http://fss.follett.com/claims/userguid',
  FSS_DISTRICT_CUSTOMER_NUMBER = 'http://fss.follett.com/claims/fssDistrictCustNumber',
  FSS_SITE_NUMBER = 'http://fss.follett.com/claims/fssSiteCustNumber',
  FLR_CUSTOMER_NUMBER = 'http://fss.follett.com/claims/dapFLRcustnbr',
  PATRON_TYPE = 'http://fss.follett.com/claims/userPatronType',
  FIRST_NAME = 'http://fss.follett.com/claims/userFirstName',
  LAST_NAME = 'http://fss.follett.com/claims/userLastName',
  DISTRICT_NAME = 'http://fss.follett.com/claims/districtName',
  LOCATION_NAME = 'http://fss.follett.com/claims/locationName',
  ROLES = 'http://fss.follett.com/claims/roles',
  NAME = 'name',
  APP_ID = 'http://fss.follett.com/claims/appId',
  LOCATION_ID = 'http://fss.follett.com/claims/locationid',
  USER_IS_GUEST = 'http://fss.follett.com/claims/userIsGuest',
  IS_ANONYMOUS = 'http://fss.follett.com/claims/userIsAnonymous',
  DISTRICT_USER = 'http://fss.follett.com/claims/districtUser',
  DESTINY_ADMIN = 'http://fss.follett.com/claims/destinyAdmin',
  FOLLETT_SHELF_ID = 'http://fss.follett.com/claims/follettShelfId',
  DISTRICT_FOLLETT_SHELF_ID = 'http://fss.follett.com/claims/districtFollettShelfId',
  DAP_ACCESS_GRANTS = 'http://fss.follett.com/claims/dapAccessGrants', // This will be a comma-delimited list of values indicating which apps a user can access. Supplied from DAP.
  FOLLETT_SHELF_ADMIN = 'http://fss.follett.com/claims/userFSAdmin',
  USER_SESSION_TIMEOUT_SECONDS = 'http://fss.follett.com/claims/aaspSessionTimeoutSeconds',
  DESTINY_FORCE_PASSWORD_RESET = 'http://fss.follett.com/claims/passwordIsNotSecure',
  DESTINY_VERSION = 'http://fss.follett.com/claims/appVersionNbr',
  DESTINY_BUILD_NUMBER = 'http://fss.follett.com/claims/appBuildNbr',
  CUST_COUNTRY = 'http://openid.net/schema/contact/country/business',
  CUST_STATE = 'http://openid.net/schema/contact/state/business',
  CUST_CITY = 'http://openid.net/schema/contact/city/business'
}

export enum DapAccessGrant {
  CLASS_SET = 'CLASS_SET',
  COLLECTIONS = 'COLLECTIONS',
	ENGAGE = 'ENGAGE',
	REVIEWS = 'REVIEWS',
	RATINGS = 'RATINGS',
	SHARING = 'SHARING',
	CITATIONS = 'CITATIONS',
	READING_CHALLENGE = 'READING_CHALLENGE',
	READING_PROGRAM = 'READING_PROGRAM'
}
